<app-key-combo-button
  icon="fas fa-search"
  [outlined]="false"
  size="small"
  label="Suche starten ..."
  [keys]="['control', 'k']"
  styleClass="p-button-shade"
  (action)="visible = true"></app-key-combo-button>

<p-dialog
  styleClass="z-top"
  maskStyleClass="z-top"
  appendTo="body"
  header="Header"
  [(visible)]="visible"
  [modal]="true"
  position="top"
  [style]="{ width: '80rem' }">
  <ng-template pTemplate="header">
    <app-search-input
      [autofocus]="true"
      inputStyleClass="w-30rem"
      placeholder="durchsuchen ..."
      (search)="search($event)"></app-search-input>
  </ng-template>

  @if (results) {
    <p-tabMenu [model]="tabs">
      <ng-template pTemplate="item" let-item>
        <a pRipple class="flex align-items-center gap-2 p-menuitem-link">
          <i [class]="item.icon"></i>
          <span class="font-bold">
            {{ item.label }}
          </span>
          <p-badge [value]="results[item.key].length" />
        </a>
      </ng-template>
    </p-tabMenu>
    @if (active && results[active] && results[active].length) {
      <p-table
        [value]="results[active]"
        [paginator]="results[active].length > 10"
        [rows]="10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[10, 25, 50]">
        <ng-template pTemplate="body" let-item>
          <tr
            *ngIf="active === 'indicators'"
            app-table-row-indicator
            [item]="item"
            [actions]="['select', 'edit']"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'dataLayerTypes'"
            app-table-row-data-layer-type
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'bookmarks'"
            app-table-row-bookmark
            [actions]="['openInAtlas']"
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'colorsets'"
            app-table-row-colorset
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'topics'"
            app-table-row-topic
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'stories'"
            app-table-row-story
            [item]="item"
            (closeEvent)="close()"></tr>
        </ng-template>
      </p-table>
    }
  } @else if (searchValues.length > 0) {
    <div class="search-history">
      <h3>Vergangene Suchen</h3>
      <ul class="list-none p-0 m-0">
        <li *ngFor="let value of searchValues">
          <a
            pRipple
            class="cursor-pointer flex align-items-center gap-2 px-1 py-3 surface-border border-bottom-1"
            (click)="quickSearch(value)"
            ><i class="fas fa-clock-rotate-left"></i> {{ value }}</a
          >
        </li>
      </ul>
    </div>
  } @else {
    <app-alert [canToggle]="false">
      Suchen Sie nach Indikatoren, Räume, Ansichten oder Dokumentationen und
      führen Schnelle Funktionen durch.
    </app-alert>
  }

  <ng-template pTemplate="footer">
    <p-button
      icon="fas fa-times"
      [rounded]="true"
      label="schließen"
      severity="secondary"
      (onClick)="close()" />
  </ng-template>
</p-dialog>
